import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/** The dayjs format shared by project grid dates and date pickers. */
export const DATE_FORMAT = 'M/D/YYYY';

/** Formats a date (in local time) as {@link DATE_FORMAT}. */
export function formatGridDate(date: Date | number): string {
  return dayjs(date).format(DATE_FORMAT);
}

export type DueDateTone = 'overdue' | 'imminent' | 'default';

export interface DueDateDisplay {
  readonly label: string;
  readonly tone: DueDateTone;
}

export function parseDueDate(dueDate: string | null | undefined): Dayjs | null {
  if (!dueDate) return null;

  const parsedDueDate = dayjs(dueDate, 'YYYY-MM-DD', true);
  return parsedDueDate.isValid() ? parsedDueDate : null;
}

export function getDueDateDisplay(dueDate: string | null | undefined, today = new Date()): DueDateDisplay | null {
  const parsedDueDate = parseDueDate(dueDate);
  if (!parsedDueDate) return null;

  // Rounded because where DST starts at midnight, that day starts at 1 AM, so a whole-day difference can be 23 hours.
  const daysFromToday = Math.round(parsedDueDate.diff(dayjs(today).startOf('day'), 'day', true));

  let label: string;
  switch (daysFromToday) {
    case -1:
      label = 'Yesterday';
      break;
    case 0:
      label = 'Today';
      break;
    case 1:
      label = 'Tomorrow';
      break;
    default:
      label = formatGridDate(parsedDueDate.toDate());
  }

  return {
    label,
    tone: daysFromToday < 0 ? 'overdue' : daysFromToday <= 1 ? 'imminent' : 'default',
  };
}
